import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleUp = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.26667 9.60005H11.7333L8 4.80005L4.26667 9.60005Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleUp)
const IconSvgTriangleUp = createIcon(ForwardRef, 'SvgTriangleUp')
export default IconSvgTriangleUp
